import { render, staticRenderFns } from "./red-wine-light.vue?vue&type=template&id=4efb6cd7"
import script from "./red-wine-light.vue?vue&type=script&lang=js"
export * from "./red-wine-light.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports